import Helpers from "../../helpers/helpers";
import { server } from "../globalSettings";

export const requestAuthOption = (method, data) => {
    let isRemember = localStorage.getItem("remember");
    let token = JSON.parse(localStorage.getItem("token"))

    if (data) {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, },
            body: JSON.stringify(data)
        };
        return requestOptions
    } else {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, },
        };
        return requestOptions
    }

}

export const branchListingApi = async (payload) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(
            `${server}profile/branches?paginate=${payload?.page}&size=${payload?.length}&search=${payload?.search}&filter[bike_branch_type]=${payload?.bike_branch_type || ''}&filter[bike_make_ids]=${payload?.make || ''}&filter[bike_make_ids]=${payload?.bike_make_ids || ''}&filter[bike_model_ids]=${payload?.bike_model_ids || ''}&filter[vehicle_source]=${payload?.vehicle_source || ''}&filter[price_range_from]=${payload?.price_range_from || ''}&filter[price_range_to]=${payload?.price_range_to || ''}&filter[created_at_from]=${payload?.created_at_from || ''}&filter[created_at_to]=${payload?.created_at_to || ''}&filter[license_category_ids]=${payload?.license_category_ids || ''}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // throw error;
            })
        })
    }
};

export const branchCreateApi = async (payload) => {
    const request = requestAuthOption("POST", payload)
    try {
        const response = await fetch(
            `${server}profile/branches/bulk-create`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // throw error;
            })
        })
    }
};

export const branchUpdateApi = async (payload) => {
    const request = requestAuthOption("PUT", payload)
    try {
        const response = await fetch(
            `${server}profile/branches/bulk-update`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // throw error;
            })
        })
    }
};

export const branchDeleteApi = async (payload) => {
    const request = requestAuthOption("DELETE", payload)
    try {
        const response = await fetch(
            `${server}profile/branches/bulk-delete`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // throw error;
            })
        })
    }
};

